import DragDropList from 'views/molecules/DragDropList/DragDropList';

export default DragDropList;
